export enum TipoCliente {
    Fisico = 1,
    Juridico = 2,
}
